import React from "react";
import AddMember from "./addmember";
import Credits from "./profilePage1";
import SaveChanges from "./savechanges";
import File from "./moresetting";

import TotalCredits from "./totalcredits";
import AnotherAccount from "./another account";
import EditIcon from "./spotmies llp";
import Number from "./newnumber";
import Here from "./spotmies";
import Card1 from "./Email";
import Card2 from "./remaining";
import Card3 from "./enable2 factor";
import ChangePasswordForm from "./changepassword";
import DisableAccount from "./diableaccount";
import DeleteAccount from "./deleteaccount";
import Addnumber from "./newnumber";
import Inputtext from "./spotmies";
import Email from "./Email";
import Remaining from "./remaining";
import Enable from "./enable2 factor";

// import Spotmies from "./Spotmies";
const Profilepage = () => {
  return (
    <div>
      <File />
      {/* <Spotmies /> */}
      <AddMember />
      {/* <Credits /> */}
      <SaveChanges />
      <TotalCredits />
      <AnotherAccount />
      <EditIcon />
      <Addnumber />
      <Inputtext />
      <Email />
      <Remaining />
      <Enable />

      <ChangePasswordForm />
      {/* <DisableAccount /> */}
      <DeleteAccount />
    </div>
  );
};
export default Profilepage;
